import safeFetch from '../../utils/safeFetch';

const getSearchResultFromUrl = (url, payload) => {
  return new Promise((resolve, reject) => {
    const computedCountry =
      window._CAAS_config?.searchCountry ??
      window?.searchCountry ??
      window._CAAS_config?.currentGroup ??
      window?.currentCountry ??
      window._CAAS_config?.locale;
    return safeFetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...payload,
        language:
          (window._CAAS_config.searchCountry
            ? window._CAAS_config.language?.replace('EN-US', 'EN')
            : window._CAAS_config.language) || window.currentLanguage,
        country: computedCountry,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
};

export default getSearchResultFromUrl;
